import { Button, Col, Modal, Row, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import API_MANAGER from "../../API";
import { useState } from "react";
import FullScreenLoader from "../../components/common/FullScreenLoader";

const DeleteUserModal = ({ data, setDeleteModal, deleteModal }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const performLogout = () => {
    const Email = localStorage.getItem("email");
    const Password = localStorage.getItem("password");
    localStorage.clear();
    if (Email && Password) {
      localStorage.setItem("email", Email);
      localStorage.setItem("password", Password);
    }
    navigate("/login");
    window?.location?.reload();
  };

  const switchToAccount = (account) => {
    localStorage.setItem("clientId", account?.recruiterId?._id);
    localStorage.setItem(
      "permissions",
      JSON.stringify(account?.permissions)
    );
    if (
      account?.recruiterId?.userId?.subscription?.[0]?.sp?.plusSubscription
    ) {
      localStorage.setItem(
        "isPlusSubscription",
        account?.recruiterId?.userId?.subscription?.[0]?.sp?.plusSubscription
      );
    } else {
      localStorage.setItem("isPlusSubscription", false);
    }
    if (
      account?.recruiterId?.userId?.subscription?.length > 0 &&
      account?.recruiterId?.userId?.subscription
    ) {
      localStorage.setItem(
        "subscription",
        JSON.stringify(account?.recruiterId?.userId?.subscription[0])
      );
    } else {
      localStorage.setItem("subscription", JSON.stringify({}));
    }
    const userType = account?.recruiterUserType
      ? account?.recruiterUserType !== "Standard"
        ? account?.recruiterUserType
        : "Account"
      : "Root";
    localStorage.setItem("user", userType);
    if (account?.recruiterUserType === "Standard") {
      if (account?.permissions?.includes(0)) {
        navigate(`/campaign-management`);
      } else if (account?.permissions?.includes(3)) {
        navigate(`/user-management`);
      }
    } else if (account?.recruiterUserType === "Associate") {
      navigate(`/job-advert`);
    } else if (
      account?.recruiterUserType === " " ||
      account?.recruiterUserType === "Admin" ||
      account
    ) {
      navigate(`/campaign-management`);
    }
    window?.location?.reload();
  };

  const handleSwitchOrLogout = async (currentClientId) => {
    let accounts = [];
    try {
      const accountsResponse = await API_MANAGER.getSwitchUserList();
      accounts = accountsResponse?.data?.data || [];
    } catch {
      performLogout();
      return;
    }
    const nextAccount = accounts?.find(
      (item) =>
        item?.recruiterId?._id !== currentClientId &&
        (item?.hasAcceptedInvite || item?.isOwner)
    );
    if (nextAccount) {
      switchToAccount(nextAccount);
    } else {
      performLogout();
    }
  };

  const handleOk = async () => {
    setLoading(true);
    try {
      await API_MANAGER.deleteUser(id);
      message.success("User successfully deleted.");

      const currentUserId = localStorage.getItem("userID");
      const currentClientId = localStorage.getItem("clientId");

      const deletedSelfById =
        id && currentUserId && String(id) === String(currentUserId);

      const deletedUserId =
        data?.user?._id ||
        data?.user?.id ||
        data?._id ||
        data?.id ||
        data?.userId?._id ||
        data?.userId;
      const deletedSelfByData =
        deletedUserId &&
        currentUserId &&
        String(deletedUserId) === String(currentUserId);

      if (deletedSelfById || deletedSelfByData) {
        setDeleteModal(false);
        await handleSwitchOrLogout(currentClientId);
        setLoading(false);
        return;
      }

      let accounts = null;
      try {
        const accountsResponse = await API_MANAGER.getSwitchUserList();
        accounts = accountsResponse?.data?.data || [];
      } catch {
        accounts = null;
      }

      if (Array.isArray(accounts)) {
        const currentStillAccessible = accounts.some(
          (item) =>
            item?.recruiterId?._id === currentClientId &&
            (item?.hasAcceptedInvite || item?.isOwner)
        );
        if (!currentStillAccessible) {
          setDeleteModal(false);
          const nextAccount = accounts.find(
            (item) =>
              item?.recruiterId?._id !== currentClientId &&
              (item?.hasAcceptedInvite || item?.isOwner)
          );
          if (nextAccount) {
            switchToAccount(nextAccount);
          } else {
            performLogout();
          }
          setLoading(false);
          return;
        }
      }

      setLoading(false);
      navigate("/user-management");
    } catch (error) {
      setLoading(false);
      message.error(
        error?.response?.data?.message?.message ||
          "Something went wrong. Please try again."
      );
    }
    setDeleteModal(false);
  };
  const handleCancel = () => {
    setDeleteModal(false);
  };
  return (
    <>
      <FullScreenLoader isLoading={loading} />
      <Modal
        title="Delete User?"
        centered
        getContainer={document.body}
        open={deleteModal}
        className="deleteUserModalMainModal"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Row>
            <Col span={24} align={"right"} className="justify_items_end">
              <Button
                key="submit"
                className="black_color_button"
                onClick={handleOk}
              >
                Okay
              </Button>
              <Button
                key="submit"
                className="cancel_btn"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              ,
            </Col>
          </Row>,
        ]}
      >
        <Row>
          <Col span={24}>
            <span className="desc">
              Are you sure, you want to delete{" "}
              <span>{data?.firstName + " " + data?.lastName}</span>{" "}
              permanently?
            </span>
          </Col>
        </Row>
      </Modal>
    </>
  );
};
export default DeleteUserModal;
